import { render, staticRenderFns } from "./bucket.vue?vue&type=template&id=011295a7&scoped=true"
import script from "./bucket.vue?vue&type=script&lang=js"
export * from "./bucket.vue?vue&type=script&lang=js"
import style0 from "./bucket.vue?vue&type=style&index=0&id=011295a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011295a7",
  null
  
)

export default component.exports